<template>
  <modal
    ref="modal"
    width="100%"
    height="100%"
    name="edit-bike"
    class="slide-modal"
    overlay-transition="slide-modal-overlay"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="close-icon-container" @click="$modal.hide('edit-bike')">
      <span class="icon">
        <img
          src="~/assets/images/icons/Close-button.svg"
          class="icon alt"
          alt="close icon"
        />
      </span>
    </div>
    <div class="slide-modal-container">
      <EditBike :bike-id="bikeId" />
    </div>
  </modal>
</template>

<script>
import EditBike from '@/components/EditBike'
import { lockBodyScroll, unlockBodyScroll } from '@/helpers/scrollLock'
export default {
  name: 'EditBikeModal',
  components: { EditBike },
  data() {
    return {
      bikeId: '',
    }
  },
  watch: {
    // Closing on navigation is what releases the body lock.
    $route() {
      this.$modal.hide('edit-bike')
    },
  },
  beforeDestroy() {
    unlockBodyScroll({ restoreScroll: false })
  },
  methods: {
    beforeOpen(event) {
      lockBodyScroll()
      this.bikeId = event.params.bikeId
    },
    beforeClose(event) {
      unlockBodyScroll()
    },
  },
}
</script>

<style lang="scss" scoped></style>
